<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <v-row dense>
        <v-col cols="12" md="6" lg="6">
          <span>COMISIONES: {{ nombreRecurso }}</span>
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-row dense>
      <v-col cols="12" md="9" xl="10">
        <v-btn class="mx-1" title="Recargar" small @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <v-btn
          v-if="!permisosDNA || permisosPresupuestos2"
          small
          class="mx-1"
          :disabled="itemSeleccionado == null"
          title="Requisitos Financieros"
          @click="$refs.modalRequisitosFinancieros.abrir(itemSeleccionado)">
          <v-icon>mdi-file-document</v-icon>
          Req. Financieros
        </v-btn>

        <v-btn
          small
          class="mx-1"
          :disabled="itemSeleccionado == null"
          title="Requisitos Documentales"
          @click="$refs.modalRequisitosDocumentales.abrir(itemSeleccionado)">
          <v-icon>mdi-file-document</v-icon>
          Req. Documentales
        </v-btn>

        <v-btn
          v-if="!permisosDNA || permisosPresupuestos2"
          small
          class="mx-1"
          :disabled="itemSeleccionado == null"
          title="Montos Comisiones"
          @click="$refs.modalMontosComisiones.abrir(itemSeleccionado)">
          <v-icon>mdi-currency-usd</v-icon>
          M. Comisiones
        </v-btn>

        <v-btn
          v-if="!permisosDNA || permisosPresupuestos2"
          small
          class="mx-1"
          :disabled="itemSeleccionado == null"
          title="Categorías Equivalentes"
          @click="$refs.modalCategoriasEquivalentes.abrir(itemSeleccionado)">
          <v-icon>mdi-shape</v-icon>
          Cat. Equivalentes
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="busqueda"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="buscar"></v-text-field>
      </v-col>

      <v-col cols="12">
        <ListadoInstituciones
          ref="listadoRef"
          :rowData="items"
          :cargando="cargando"
          @seleccionarItem="seleccionarItem" />
      </v-col>
    </v-row>

    <ModalRequisitosFinancieros ref="modalRequisitosFinancieros" titulo="REQUISITOS FINANCIEROS" />

    <ModalRequisitosDocumentales ref="modalRequisitosDocumentales" titulo="REQUISITOS DOCUMENTALES" />

    <ModalMontosComisiones ref="modalMontosComisiones" titulo="MONTOS COMISIONES" />

    <ModalCategoriasEquivalentes ref="modalCategoriasEquivalentes" titulo="CATEGORÍAS EQUIVALENTES" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import InstitucionesService from '../services/instituciones.service';
import ListadoInstituciones from './components/ListadoInstituciones';
import ModalRequisitosFinancieros from './components/ModalRequisitosFinancieros.vue';
import ModalRequisitosDocumentales from './components/ModalRequisitosDocumentales.vue';
import ModalMontosComisiones from './components/ModalMontosComisiones.vue';
import ModalCategoriasEquivalentes from './components/ModalCategoriasEquivalentes.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'InstitucionesLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoInstituciones,
    ModalRequisitosFinancieros,
    ModalRequisitosDocumentales,
    ModalMontosComisiones,
    ModalCategoriasEquivalentes,
  },
  data() {
    return {
      nombreRecurso: 'INSTITUCIONES',
    };
  },
  mounted() {
    this.listar();
  },
  computed: {
    ...mapGetters({
      permisosDNA: 'comision/permisosDNA',
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
    }),
  },
  methods: {
    async listar() {
      await this.findAllMixin(
        InstitucionesService.findAll,
        null,
        this.nombreRecurso,
        () => {
          this.items = [];
          this.itemSeleccionado = null;
          this.cargando = true;
        },
        () => {
          this.cargando = false;
        },
        (datos) => {
          this.items = datos;
        },
        () => {
          this.items = [];
          this.itemSeleccionado = null;
        },
      );
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>